if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        if (
          this.querySelector('form') &&
          this.querySelector("[type='submit']")
        ) {
          this.init();
        }
        //handle PPR file upload
        // this.addEventListener('change', this.handleFileUpload.bind(this))
      }
      init() {
        this.cart_page = document.querySelector('cart-items');
        this.form = this.querySelector('form');

        var id_input =
          this.form.querySelector('[name=id]') ||
          this.form.querySelector('[name="items[0][id]"]');
        id_input.disabled = false;

        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        this.wrappingProducts = this.dataset.wrappingProducts;
        this.wrappingProductKey = this.dataset.wrappingProductKey;
        this.currentVariant;

        if (document.querySelector('cart-drawer'))
          this.submitButton.setAttribute('aria-haspopup', 'dialog');

        var product_container = this.closest('.product');

        if (product_container) {
          this.initEngravable(product_container);
        }

        //new etch
        const configuratorTriggers =
          document.querySelectorAll('.show-configurator');
        const configuratorModal = document.querySelector(
          '.product-configurator-modal',
        );

        if (configuratorTriggers && configuratorModal) {
          configuratorTriggers.forEach((el) => {
            el.addEventListener('click', (e) => {
              e.preventDefault();
              document.body.classList.add('overflow-hidden');
              configuratorModal.classList.add('active');
            });
          });

          //render canvas for comb list
          document.dispatchEvent(new CustomEvent('monogramChanged', {}));
        }

        //on variant change, set wrapping products to include new variant
        document.body.addEventListener(
          'variantChange',
          this.handleVariantChange.bind(this),
        );

        //handle PPR file upload
        // this.addEventListener('change', this.handleFileUpload.bind(this))
      }

      handleVariantChange(e) {
        var current_variant = e.detail.currentVariant;

        if (!current_variant) return;

        this.currentVariant = current_variant;
      }

      async onSubmitHandler(evt, skip_drawer = false) {
        evt.preventDefault();

        // A surface that proxies this form's submit (e.g. the UGC reel) can hand
        // off a one-shot PostHog source via window.__phSourceOverrides, keyed by
        // event name. Read + consume it synchronously here — before any early
        // return or await — so it binds to exactly this submit and can never leak
        // into a later add.
        var phOverrides = window.__phSourceOverrides;
        this._phSourceOverride = (phOverrides && phOverrides.add_to_cart) || null;
        if (phOverrides) delete phOverrides.add_to_cart;

        var pp_check = evt.target
          .closest('form')
          .querySelector('.product-personalizer');

        // var matches_check = pp_check.matches(".product-personalizer")
        if (pp_check?.classList.contains('product-personalizer')) {
          return;
        }

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        //check for matching accompanying products
        const aprod_el = document.querySelector(
          `accompanying-products[data-product-form="${this.form.getAttribute('id')}"]`,
        );

        if (aprod_el) {
          //has matching aprod, check to see if select input is required and has value that is not disabled
          const select_input = aprod_el.querySelector('select');
          if (
            select_input &&
            select_input.required &&
            select_input.value == ''
          ) {
            this.handleErrorMessage('Please select an option');
            return;
          }
        }

        const validateEvent = new CustomEvent('locket:validate', {
          cancelable: true,
          bubbles: true,
        });
        this.form.dispatchEvent(validateEvent);

        if (validateEvent.defaultPrevented) return;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove(
          'hidden',
        );

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          if (!this.cart_page) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id),
            );
          } else {
            formData.append(
              'sections',
              this.cart_page
                .getSectionsToRender()
                .map((section) => section.section),
            );
          }
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        if (this.wrappingProducts) {
          //default is to have product wrapped
          var name = this.currentVariant
            ? this.currentVariant.name
            : this.dataset.base;
          if (name && name != '') {
            formData.append(
              `attributes[${this.wrappingProductKey}]`,
              `${this.wrappingProducts}, ${name}`,
            );
          }
        }

        config.body = formData;

        return fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            // Successful add — fire the add_to_cart anchor event (one per line
            // item; see capturePhAddToCart). formData carries the submit-time
            // quantities so we log what was just added, not the cart total.
            this.capturePhAddToCart(response, formData);

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              if (!this.hasAttribute('data-cart-page')) {
                this.cart.renderContents(response, skip_drawer);
              } else {
                const cart_page = document.querySelector('cart-items');

                if (cart_page) {
                  cart_page.renderContent(response);
                }
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty'))
              this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add(
              'hidden',
            );
          });
      }

      capturePhAddToCart(response, formData) {
        try {
          if (typeof posthog === 'undefined') return;

          // Every line from a single submit shares one add_id, so a multi-item
          // create-app bundle can be collapsed back to one add action via
          // unique(add_id). A single PDP/quick-add is just a bundle of one.
          var addId =
            self.crypto && crypto.randomUUID
              ? crypto.randomUUID()
              : 'add_' + Date.now() + '_' + Math.random().toString(36).slice(2);

          // The quick-add modal fetches & clones the PDP markup, so its form
          // carries the PDP's data-ph-source — detect that case at runtime.
          // Every other surface declares its own source via data-ph-source;
          // anything unlabeled logs as 'unknown' so new surfaces stay visible
          // rather than silently inflating 'pdp'.
          // A proxied submit's one-shot override (read in onSubmitHandler) wins,
          // so a reel add logs source 'ugc' rather than the PDP form's own source.
          var source = this._phSourceOverride
            ? this._phSourceOverride
            : this.closest('quick-add-modal')
              ? 'quick_add'
              : this.dataset.phSource || 'unknown';

          // The /cart/add.js response reports each line's *cumulative* cart
          // quantity, not what was just added — so a product already in the
          // cart reports the wrong number. Derive the delta from what was
          // submitted, keyed by variant id. Handles both form shapes (single
          // `id` and `items[n][id]`) and same-variant merges.
          var addedQty = {};
          if (formData) {
            if (formData.has('id')) {
              var svid = String(formData.get('id'));
              addedQty[svid] =
                (addedQty[svid] || 0) +
                (parseInt(formData.get('quantity'), 10) || 1);
            }
            for (var entry of formData.entries()) {
              var match = entry[0].match(/^items\[(\d+)\]\[id\]$/);
              if (!match) continue;
              var ivid = String(entry[1]);
              var iqty =
                parseInt(
                  formData.get('items[' + match[1] + '][quantity]'),
                  10,
                ) || 1;
              addedQty[ivid] = (addedQty[ivid] || 0) + iqty;
            }
          }

          // /cart/add.js returns { items: [...] } for a multi-item add, or the
          // line item object directly for a single add.
          var lines = Array.isArray(response.items)
            ? response.items
            : [response];

          lines.forEach(function (item) {
            if (!item || !item.product_id) return;
            var vid = String(
              item.variant_id != null ? item.variant_id : item.id,
            );
            posthog.capture('add_to_cart', {
              product_id: String(item.product_id), // real per-item id
              product_name: item.product_title,
              price: (item.price || 0) / 100, // per-item unit price, dollars
              // 'add_source', not 'source': PostHog reserves/populates its own
              // 'source', which shadowed this value and broke filtering.
              add_source: source,
              add_id: addId,
              quantity: addedQty[vid] || 1, // qty added now, not cart total
            });
          });
        } catch (e) {
          // never let analytics break add-to-cart
        }
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message',
          );

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      initEngravable(container) {
        var pp_check = document.querySelector('.product-personalizer');

        if (!container.hasAttribute('data-engravable')) return;

        container.addEventListener('change', (e) => {
          if (!e.target.matches('.pplr-wrapper.pplr-checkbox input')) return;

          let checkbox_state = e.target.checked;
          container.dataset.unetched = checkbox_state;

          // if(!checkbox_state) return

          //if true, remove current values for etching
          const current_input = container.querySelectorAll(
            '[data-engravable] .pplr-wrapper [type=text],[data-engravable] .pplr-wrapper textarea',
          );
          Array.from(current_input).forEach((input) => {
            const input_name = input.name;

            if (checkbox_state) {
              input.value = '';
            }
          });
        });

        var handle = container.dataset.productHandle;
        var paceholders = container.dataset.etchPlaceholder?.split(',') || [];

        var MONOGRAM_PLACEHOLDER = 'Enter monogram initials';
        var SINGLE_MONOGRAM_PLACEHOLDER = 'Enter monogram initial';
        var NAME_PLACEHOLDER = 'Enter names';
        //etch bracelet placeholder
        SINGLE_MONOGRAM_PLACEHOLDER = false;

        if (
          handle.includes('bracelet') ||
          handle.includes('engravable-hexagon') ||
          handle.includes('etch-hive') ||
          handle.includes('etch-orbit')
        ) {
          MONOGRAM_PLACEHOLDER = 'Enter Front Alpha';
          NAME_PLACEHOLDER = 'Enter Back Alpha';
        }

        if (handle.includes('etch-chain')) {
          MONOGRAM_PLACEHOLDER = 'Enter Front Text';
          NAME_PLACEHOLDER = 'Enter Back Text';
        }

        if (handle.includes('studs')) {
          MONOGRAM_PLACEHOLDER = 'Enter Left Stud';
          NAME_PLACEHOLDER = 'Enter Right Stud';
        }

        if (handle.includes('empower')) {
          MONOGRAM_PLACEHOLDER = 'Enter Your Quote. 12 Characters Per Line';
        }

        if (handle.includes('illustrate')) {
          MONOGRAM_PLACEHOLDER = 'Side One: Enter monogram initial';
        }

        if (handle.includes('illustrate-pendant')) {
          MONOGRAM_PLACEHOLDER =
            'Side one: enter initials or up to 30 characters';
        }

        if (handle == 'etch-bar-necklace') {
          MONOGRAM_PLACEHOLDER = 'Side one: Enter name/date';
          NAME_PLACEHOLDER = 'Side two: Enter name/date';
        }

        if (handle.includes('etch-behold')) {
          NAME_PLACEHOLDER = 'Enter date/word';
        }

        if (handle.includes('bridesmaids-set')) {
          MONOGRAM_PLACEHOLDER = 'Enter date/word';
        }
        if (handle.includes('etch-rope')) {
          NAME_PLACEHOLDER = 'Enter Message';
        }
        if (handle.includes('inspire')) {
          MONOGRAM_PLACEHOLDER = 'Enter Your Quote. 10 Characters Per Line';
        }

        //app placeholder creates shadow DOM div within input, setting preview to placeholder
        //  set post app load
        var pp_check = document.querySelector('.product-personalizer');

        if (pp_check) {
          const pp_text_inputs = container.querySelectorAll(
            '.pplr-wrapper [type=text]',
          );
          console.log(pp_text_inputs);
          if (pp_text_inputs[0]) {
            setupCustom(
              container.querySelectorAll('.pplr-wrapper [type=text]'),
              container,
            );
          } else {
            console.log('---- No inputs ----');
            console.log(pp_check.cloneNode(true));
            var one_pp_observer = false;
            var one_pp_font_observer = false;

            // Options for the observer (which mutations to observe)
            const config = { attributes: true, childList: true, subtree: true };

            // Callback function to execute when mutations are observed
            const callback = function (mutationsList, observer) {
              // Use traditional 'for loops' for IE 11
              for (const mutation of mutationsList) {
                if (one_pp_observer) {
                  observer.disconnect();
                }
                if (mutation.type === 'childList') {
                  //check font changer, if it exists, hide and only show one
                  if (
                    !one_pp_font_observer &&
                    container.querySelector('.pplr-font-select')
                  ) {
                    one_pp_font_observer = true;

                    const all_font_selects =
                      container.querySelectorAll('.pplr-font-select');
                    var current_font_names = []; //font selects with matching names will change the same fonts

                    //position the font selects before their corresponding inputs
                    all_font_selects.forEach((font_select, i) => {
                      const font_index = font_select.dataset.frame;
                      const font_name = font_select.querySelector('input').name;
                      const input = pp_check.querySelector(
                        `.pplr-wrapper[data-main="${font_index}"]`,
                      );

                      if (current_font_names.includes(font_name)) {
                        font_select.dataset.hidden = true;
                      } else {
                        font_select.dataset.index = i;
                        font_select.dataset.hidden = false;
                      }
                      current_font_names.push(font_name);
                      input.before(font_select);
                    });

                    //when variant changes, ppr is rechecking fonts -> hiding top one
                  }

                  //story locket always shows the etch preview
                  // when clicked, trigger input (make etch) => trigger preview
                  // if (one_pp_story_obsetver == false && handle.includes("story")) {
                  // 	one_pp_story_obsetver = true

                  // 	//get first input
                  // 	const input = container.querySelector(".pplr-wrapper [type=text], .pplr-wrapper textarea")
                  // 	const preview_button = container.querySelector(".pplr-preview-btn")
                  // 	if (input && preview_button) {
                  // 		const input_function = input.oninput
                  // 		const preview_function = preview_button.onclick

                  // 		function handlePreview(e) {
                  // 			e.preventDefault()
                  // 			const input_event = new InputEvent("input", { bubbles: true })

                  // 			debugger
                  // 			input.dispatchEvent(input_event)
                  // 			e.target.inlineHandler.call(preview_button, e)
                  // 		}

                  // 		//change preview button onclick to trigger input, then trigger inline on click function
                  // 		const original_handler = preview_button.onclick

                  // 		preview_button.onclick = handlePreview
                  // 		preview_button.inlineHandler = original_handler
                  // 	}
                  // }

                  // const pp_text_inputs = container.querySelectorAll('.pplr-wrapper [type=text]')
                  if (
                    container.querySelectorAll('.pplr-wrapper [type=text]')
                      .length > 0 &&
                    !one_pp_observer
                  ) {
                    setupCustom(
                      container.querySelectorAll('.pplr-wrapper [type=text]'),
                      container,
                    );
                    one_pp_observer = true;
                    observer.disconnect();
                  }
                }
              }
            };

            // Create an observer instance linked to the callback function
            const observer = new MutationObserver(callback);

            // Start observing the target node for configured mutations
            observer.observe(pp_check, config);
          }
        }
        function setupCustom(inputs, container) {
          Array.from(inputs).forEach((input, index) => {
            //NEW META FILED WAY
            if (paceholders.length > 0) {
              input.placeholder = paceholders[index % paceholders.length];
            } else {
              if (
                handle == 'engravable-oval-charm' ||
                handle == 'etch-amore-necklace'
              ) {
                //starting to get so messy...
                if (index == 0) {
                  input.placeholder =
                    input.dataset.maxlength == 1 && SINGLE_MONOGRAM_PLACEHOLDER
                      ? SINGLE_MONOGRAM_PLACEHOLDER
                      : MONOGRAM_PLACEHOLDER;
                } else {
                  input.placeholder = `Enter name ${index}`;
                }
              } else if (container.hasAttribute('data-vida')) {
                switch (index) {
                  case 0:
                    input.placeholder =
                      input.dataset.maxlength == 1 &&
                      SINGLE_MONOGRAM_PLACEHOLDER
                        ? SINGLE_MONOGRAM_PLACEHOLDER
                        : MONOGRAM_PLACEHOLDER;
                    break;
                  case 1:
                    input.placeholder = 'Enter Top Etch';
                    break;
                  case 2:
                    input.placeholder = 'Enter Middle Etch';
                    break;
                  case 3:
                    input.placeholder = 'Enter Bottom Etch';
                    break;
                }
              } else if (handle.includes('story')) {
                switch (index) {
                  case 0:
                    input.placeholder = 'Front Of Locket Text';
                    break;
                  case 1:
                    input.placeholder = 'Inside Panel Front Text';
                    break;
                  case 2:
                    input.placeholder = 'Inside Panel Back Text';
                    break;
                }
              } else {
                let even_check = index % 2;
                switch (even_check) {
                  case 0:
                    input.placeholder =
                      input.dataset.maxlength == 1 &&
                      SINGLE_MONOGRAM_PLACEHOLDER
                        ? SINGLE_MONOGRAM_PLACEHOLDER
                        : MONOGRAM_PLACEHOLDER;
                    break;

                  case 1:
                    input.placeholder = NAME_PLACEHOLDER;
                    break;
                }
              }
            }

            //app only allows Alphanumeric numbers,
            //& . should be allowed, therefore custom match
            if (input.oninput) {
              const app_input_event = input.oninput;
              input.oninput = '';
              const input_wrapper = input.closest('.pplr-wrapper');
              input.addEventListener('input', (e) => {
                //remove anything that is not
                //  alphanumeric
                //  whitespace
                //  & . + ,
                var pattern =
                  /[^a-zA-Z0-9&.+° ,'"\t\n`~!@#$%^*()\-_={}\[\]|\\:;<>?/]+/g;

                let found = input.value.match(pattern);
                console.log(input.value, found);
                if (found) {
                  input.value = input.value.replace(pattern, '');
                  if (input_wrapper) {
                    if (
                      input_wrapper.classList.contains('show-warning--textarea')
                    ) {
                      input_wrapper.classList.remove('show-warning--textarea');
                    }
                    input_wrapper.classList.add('show-warning');
                  }
                } else {
                  if (input_wrapper) {
                    input_wrapper.classList.remove('show-warning');
                  }
                }
                //only allow 10 chars per line within vida
                if (input.type == 'textarea') {
                  //need to filter for vida
                  const app_input_event = input.oninput;
                  input.oninput = '';
                  let max_lines = input.getAttribute('maxline');
                  let max_chars = input.dataset.maxlength;
                  let char_limit =
                    max_lines && max_chars
                      ? parseInt(parseInt(max_chars) / parseInt(max_lines))
                      : 5;

                  let current_encoded_value = encodeURIComponent(input.value);
                  var line_length = handle.includes('empower') ? 12 : 10; //for empower charm
                  if (
                    !handle.includes('empower') &&
                    !handle.includes('etch-rope') &&
                    !handle.includes('inspire') &&
                    !handle.includes('story') &&
                    !handle.includes('etch-birthstone')
                  ) {
                    current_encoded_value = current_encoded_value.replace(
                      /\%20/g,
                      '',
                    ); //remove all spaces
                    // line_length = 10
                  }

                  input_wrapper.dataset.maxLines = line_length; //used in CSS attr()

                  let current_array = current_encoded_value.split('%0A'); //broken on new line

                  for (let i = 0; i < current_array.length; i++) {
                    const line = decodeURIComponent(current_array[i]); // decode so space is not 2 chars

                    if (handle.includes('etch-rope')) {
                      //etch rope has max 10 top and bottom and max 12 both middle
                      line_length = 12;

                      if (i == 0 || i == 3) {
                        line_length = 10;
                      }

                      input_wrapper.dataset.maxLines = line_length;
                    }
                    console.log(line.length, line_length / 2);

                    //last line is over total
                    if (line.length > line_length) {
                      let capped_line = line.substring(0, line_length); //remove last char of offending line

                      //puts on new line
                      if (i == current_array.length - 1) {
                        capped_line = capped_line + '\r\n';
                      }
                      current_array[i] = capped_line;

                      input_wrapper.classList.add('show-warning--textarea');
                    } else if (
                      current_array[current_array.length - 1].length > 3 &&
                      input_wrapper.classList.contains('show-warning--textarea')
                    ) {
                      input_wrapper.classList.remove('show-warning--textarea');
                    }
                  }

                  //story locket has one font forced uppercase

                  input.value = decodeURIComponent(current_array.join('\r\n'));

                  //Handle max lines
                  const max_lines_attb = input.getAttribute('maxline');
                  if (max_lines) {
                    const max_lines = parseInt(max_lines_attb);
                    if (current_array.length > max_lines) {
                      current_array = current_array.slice(0, max_lines);
                      input.value = decodeURIComponent(
                        current_array.join('\r\n'),
                      );
                    }
                  }
                }
                app_input_event;
              });
            }
          });
        }
      }

      // handleFileUpload(e){
      //   const input = e.target
      //   if(!input.classList.contains('fileupload')) return

      //   var value =
      // }
    },
  );
}
